/*
 * @Author: your name
 * @Date: 2021-12-27 14:14:58
 * @LastEditTime: 2022-01-11 18:47:27
 * @LastEditors: Please set LastEditors
 * @Description: 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 * @FilePath: \bidding-systemd:\项目\engineer-management-system\src\views\PC\Purchase\purchase-list\purchase-list-api.js
 */
import * as API from '@/api/index'
/* 采购单列表 */
export const queryPurchaseList = (params) => {
    return API.POST(`/MhProjectPurchaseController/queryPurchaseList`, params, {}, true)
}

/* 查询采购单日志 */
export const queryPurchaseLog = (params) => {
    return API.POST(`/MhProjectPurchaseController/queryPurchaseLog`, params, {}, true)
}

/* 删除采购单*/
export const delPurchase = (params) => {
    return API.POST(`/MhProjectPurchaseController/deletePurchase`, params, {}, true)
}



/* 查询项目分类字典 */
export const findProjectCategory = (type, params) => {
    return API.POST(`/Mh01ProjectController/basedict/?kind=${type}`, params, {}, true)
}

/* 查询项目下拉列表 */
export const findProjectDownList = (params) => {
    return API.POST('/Mh01ProjectController/findProjectInfoList', params, {}, true)
}

/* 查询采购单name下拉列表 */
export const queryPurchaseSelector = (params) => {
    return API.POST('/MhProjectPurchaseController/queryPurchaseSelector', params, {}, true)
}

/* 新增日志 */
export const addActualHour = (params) => {
    return API.POST('/Mh02ActualHourController/addActualHour', params, {}, true)
}

/* 项目采购单审核 */
export const checkPurchase = (params) => {
    return API.POST(`/MhProjectPurchaseController/checkPurchase`, params, {}, true)
}